<template>
  <my-dialog
    form-title="协助接入"
    confirm-button="邀请"
    :dialog-carted="isShowAssistant"
    :width="452"
    @confirmOk="confirmBtn"
  >
    <template #content>
      <div>
        <div class="line-one">
          <span>科室</span>
          <el-select
            v-model="room"
            placeholder="-------"
            @change="changeRoomValue"
          >
            <el-option
              v-for="item in roomOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="line-two">
          <div
            v-for="(person) in persons"
            :key="person.id"
            class="person"
            :class="{'is-selected': selectId.includes(person.id)}"
            @click="clickOne(person)"
          >
            <div class="image-body"/>
            <span>{{ person.value }}</span>
          </div>
        </div>
        <!--        <div class="line-three check-container">-->
        <!--          <el-checkbox-->
        <!--            v-for="item in group"-->
        <!--            :key="item.id"-->
        <!--            v-model="groupForm[item.id]"-->
        <!--          >-->
        <!--            {{ item.group }}-->
        <!--          </el-checkbox>-->
        <!--        </div>-->
        <div class="line-three">
          <span>已选: </span>
          <span>{{ showSelectNames.join("，") }}</span>
        </div>
      </div>
    </template>
  </my-dialog>
</template>

<script>
import MyDialog from "@components/customDialog/MyDialog";
import { getDepartUser, inviteAssistantUser } from "@api/user";
import { showWindowMessage } from "@utils/notification";
import { getHospitalDepartments } from "@api/getOptions";

export default {
  name: "AssistantDialog",
  components: {
    MyDialog
  },
  props: {
    isShowAssistant: {
      type: Boolean,
      default: false
    },
    patientID: {
      type: Number,
      default: 0
    }
  },
  emits: ["closeDialog"],
  data() {
    return {
      selectId: [],
      room: "",
      selectNames: [], // 下方表示已经选中的名字列表
      roomOptions: [],
      chooseOptions: ["胸痛", "卒中"],
      checkedOptions: [],
      persons: [],
      group: [],
      groupForm: {},
    };
  },
  computed: {
    showSelectNames() {
      // 按照拼音首字母排序
      return this.selectNames.map(item => {
        return item.showName;
      }).sort();
    }
  },
  watch: {
    // 还没有想好怎么写
    // groupForm: {
    //   handler(val) {
    //     const keysWithTrueValue = [];
    //     for (const key in val) {
    //       if (val[key] === true) {
    //         keysWithTrueValue.push(key);
    //       }
    //     }
    //     if (keysWithTrueValue.length === 0) {
    //       return;
    //     }
    //     const arr = this.group.filter((item) => {
    //       return keysWithTrueValue.includes(item.id + "");
    //     });
    //     let arr2 = [];
    //     arr.forEach(item => {
    //       arr2 = [...arr2, ...item.users];
    //     });
    //     const mergedArr = arr2.reduce((accumulator, currentObj) => {
    //       const existingObj = accumulator.find(obj => obj.id === currentObj.id);
    //       if (existingObj) {
    //         // 如果存在相同属性值的对象，则合并它们
    //         existingObj.id = currentObj.id;
    //       } else {
    //         // 否则将当前对象添加到累加器中
    //         accumulator.push(currentObj);
    //       }
    //       return accumulator;
    //     }, []);
    //     const allId = mergedArr.map((item) => {
    //       return item.id;
    //     });
    //     console.log(allId);
    //     this.persons.forEach((item, index) => {
    //       console.log(item);
    //       if (!allId.includes(item.id)) {
    //         this.persons.splice(index, 1);
    //       }
    //     });
    //   },
    //   // immediate: true,
    //   deep: true
    // }
  },
  mounted() {
    this.getDialogOptionData();
  },
  methods: {
    /**
     * 弹窗 点击到一个医生
     * @param {number} id - 医生的id
     * */
    clickOne({ id }) {
      // 判断是否已经存起来了
      const isSelectIndex = this.selectId.indexOf(id);
      if (isSelectIndex !== -1) {
        // 已经存在了
        this.selectId.splice(isSelectIndex, 1);
      } else {
        this.selectId.push(id);
      }
      this.selectNames = [];
      this.selectId.forEach(item => {
        const person = this.allUser.find(p => {
          return p.id === item;
        });
        if (person) {
          const temp = {
            id: person.id,
            showName: `${person.room}-${person.value}`
          };
          this.selectNames.push(temp);
        }
      });
    },
    /**
     * 下拉框 选择新的科室
     * @param {String} roomValue - 选择的科室
     * */
    changeRoomValue(roomValue) {
      if (!roomValue) {
        this.persons = this.allUser;
        return;
      }
      const selectRoomValueList = this.department.find(item => {
        return item.departmenr === roomValue;
      });
      if (!selectRoomValueList) {
        showWindowMessage(3, "没有该科室下的数据", this);
      }
      this.persons = selectRoomValueList.users;
    },
    /**
     * 点击邀请
     * */
    async confirmBtn(isOk) {
      if (isOk) {
        if (!this.selectId.length) {
          showWindowMessage(3, "请选择用户后再点击邀请", this);
          return;
        }
        const data = {
          "users": this.selectId,
          "medicalhistory_id": this.patientID
        };
        try {
          const { code, msg } = await inviteAssistantUser(JSON.stringify(data));
          showWindowMessage(code === 200 ? 4 : 3, msg, this);
        } catch (e) {
          showWindowMessage(3, e, this);
        }
      }
      this.$emit("closeDialog");
    },
    /**
     * 拿到邀请弹窗选项需要的数据
     * */
    async getDialogOptionData() {
      const { code, department } = await getDepartUser();
      const { code: code2, group } = await getHospitalDepartments();
      console.log("------------------1");
      if (code !== 200 || code2 !== 200) {
        showWindowMessage(3, "获取排班弹窗数据失败, 请重试", this);
        return;
      }
      this.group = group;
      group.forEach(item => {
        this.groupForm[item.id] = false;
      });

      department.forEach(({ departmenr, users }) => {
        users.forEach(user => {
          user.value = user.name;
          user.room = departmenr;
        });
      });
      let allUser = [];
      department.forEach(item => {
        allUser = [...allUser, ...item?.users];
      });
      this.allUser = allUser;
      this.persons = allUser;

      this.department = department;
      this.roomOptions = department.map(({ departmenr }) => {
        return {
          label: departmenr,
          value: departmenr
        };
      });
      this.roomOptions.unshift({
        label: "全部",
        value: ""
      });
    }
  }
};
</script>

<style scoped lang="scss">
.line-one {
  text-align: left;
  margin-bottom: 20px;

  > span {
    font-size: 16px;
    color: #666666;
    margin-right: 24px;
  }

  .el-select {
    width: 140px;
    height: 32px;

    ::v-deep {
      input {
        height: 32px;
      }
    }
  }
}

.line-two {
  display: flex;
  background: #F0F5F7;
  padding: 20px;
  height: 168px;
  overflow: auto;
  flex-wrap: wrap;
  width: 364px;

  .is-selected {
    font-size: 14px;
    color: #2AA5E3;
  }

  .person {
    cursor: pointer;
    text-align: center;
    width: 50px;
    font-size: 14px;

    span {
      overflow: hidden;
      text-overflow: ellipsis; //超出部分以省略号显示
      white-space: nowrap;
      display: inline-block;
      width: 50px; //用px单位亦可行
    }
  }

  .image-body {
    background: url(../../assets/photos2/user.png) no-repeat center center;
    width: 30px;
    height: 30px;
    margin: auto;
  }
}

.is-selected {
  .image-body {
    background: url(../../assets/photos2/user-select.png) no-repeat center center;
  }
}

.line-three {
  margin-top: 20px;
  text-align: left;
}
</style>
